export const environment = {
  production: true,
  BACKEND_URL: 'https://ibo-staging2.devdock.space.one',
  SCOPE_KEY: 'ibo',
  CLIENT_ID: 'HFc2Idtr0IxkJY1BHvDgOpeWRi2gzbz1',
  version: '2.0.8'
};
